import type { PostDevicesSearchRequestBody } from '@ulysses-inc/harami_api_client'
import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

export const queryKeys = {
  devicesAll: [...queryKeyPrefix.devices],
  devices: (params: {
    filter: PostDevicesSearchRequestBody
    offset: number
    limit: number
  }) => [...queryKeyPrefix.devices, params] as const,
  /** キオスク端末画面の絞り込み・編集で使う現場ノード */
  placeNodes: [...queryKeyPrefix.devices, 'placeNodes'],
}
